import type { Address } from "viem"
import { useParams } from "react-router-dom"
import { observer } from "mobx-react-lite"

import { ShowWhenTrue } from "@/components/conditionals"
import { TooltipProvider } from "@/components/tooltip"
import { ClFarmsPageLayout } from "@/domains/cl-farms-page/components/cl-farms-page-layout"
import { MintFertilizerClFarmPair } from "@/domains/cl-farms-page/components/fertilizer/mint-fertilizer-cl-farm-pair"
import { MintGammaClFarmPair } from "@/domains/cl-farms-page/components/gamma/mint-gamma-cl-farm-pair"
import { MintIchiClFarmPair } from "@/domains/cl-farms-page/components/ichi/mint-ichi-cl-farm-pair"
import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { PageTitle } from "@/domains/common/layout/page-title"
import { ClFarmsPagesComplexBreadcrumbApplication } from "@/domains/navigation/components/complex-breadcrumb-applications/cl-farms-pages-complex-breadcrumb-application"
import { ClFarmsLiquiditySubItem } from "@/domains/navigation/subitems/clfarms-liquidity-subitem"
import { useClFarm } from "@/hooks/use-cl-farm"

const BREADCRUMB_ITEMS = [new ClFarmsLiquiditySubItem(), ClFarmsPagesComplexBreadcrumbApplication]

const CLFarmsMintWrapper = observer(() => {
  const { address: clFarmAddressParam } = useParams<{ address: string }>()
  const clFarmAddress = clFarmAddressParam ? (clFarmAddressParam as Address) : undefined
  const clFarm = useClFarm(clFarmAddress)

  const title = clFarm ? `Mint ${clFarm.displayName} CL Farms Liquidity` : "Mint CL Farms Liquidity"
  const subTitle = "for boosted rewards with liquidity automation"

  return (
    <TooltipProvider>
      <PageContainer>
        <MetaData title={title} />
        <PageTitle title="Mint CL Farms Liquidity" subTitle={subTitle} items={BREADCRUMB_ITEMS} />

        <ClFarmsPageLayout
          clFarmAddress={clFarmAddress}
          clFarm={clFarm}
          leftColumn={
            <>
              <ShowWhenTrue when={!!clFarm && clFarm.alm === "Fertilizer"}>
                <MintFertilizerClFarmPair clFarm={clFarm} />
              </ShowWhenTrue>
              <ShowWhenTrue when={!!clFarm && clFarm.alm === "Gamma"}>
                <MintGammaClFarmPair clFarm={clFarm} />
              </ShowWhenTrue>
              <ShowWhenTrue when={!!clFarm && clFarm.alm === "Ichi"}>
                <MintIchiClFarmPair clFarm={clFarm} />
              </ShowWhenTrue>

              <ShowWhenTrue when={!!clFarm && clFarm.alm === "Steer"}>
                Current disabled during refactoring
                {/* <MintSteerClFarmPair clFarm={clFarm} /> */}
              </ShowWhenTrue>
            </>
          }
        />
      </PageContainer>
    </TooltipProvider>
  )
})

export default CLFarmsMintWrapper
